import {
  REMOVE_NOTIFICATION,
  SET_NOTIFICATION
} from "../actions/notificationActions";

const initState = [];

const notificationsReducer = (notifications = initState, action) => {
  switch (action.type) {
    case SET_NOTIFICATION:
      return [...notifications, action.payload];

    case REMOVE_NOTIFICATION:
      return notifications.filter(
        notification => notification.id !== action.payload
      );

    default:
      return notifications;
  }
};

export default notificationsReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/notificationsReducer.js